import { STACK_VIBECODE } from '../nodes/Stack.vibecode';
import { GRID_VIBECODE } from '../nodes/Grid.vibecode';
import { FLEX_VIBECODE } from '../nodes/Flex.vibecode';
import { FIELD_ROW_VIBECODE } from '../nodes/FieldRow.vibecode';
import { CONDITIONAL_VIBECODE } from '../nodes/Conditional.vibecode';
import { DISABLED_WHEN_VIBECODE } from '../nodes/DisabledWhenBlock.vibecode';
import { TABLE_VIBECODE } from '../nodes/Table.vibecode';
import { SUM_VIBECODE } from '../deriveLayoutTotals';
import { OASIS_TIME_VIBECODE } from '../../primitives/OASISTime';
import { OASIS_YES_NO_CHECKBOX_VIBECODE } from '../../primitives/OASISYesNoCheckbox';
import { OASIS_MULTISELECT_VIBECODE } from '../../primitives/OASISMultiselect';
import { OASIS_MULTISELECT_OPTION_VIBECODE } from '../../primitives/OASISMultiselectOption';
import { RADIO_OPTION_VIBECODE } from '../../primitives/OASISRadioOption';

const LAYOUT_NODE_VIBECODE_SNIPPETS: readonly string[] = [
  STACK_VIBECODE,
  GRID_VIBECODE,
  FLEX_VIBECODE,
  FIELD_ROW_VIBECODE,
  TABLE_VIBECODE,
  CONDITIONAL_VIBECODE,
  DISABLED_WHEN_VIBECODE,
  SUM_VIBECODE,
  OASIS_YES_NO_CHECKBOX_VIBECODE,
  OASIS_TIME_VIBECODE,
  OASIS_MULTISELECT_VIBECODE,
  OASIS_MULTISELECT_OPTION_VIBECODE,
  RADIO_OPTION_VIBECODE,
];

export function composeLayoutNodeVibecodeSection(): string {
  const snippets = LAYOUT_NODE_VIBECODE_SNIPPETS.map(s => s.trim()).filter(
    Boolean
  );
  if (snippets.length === 0) {
    return '';
  }
  return [
    '## Node notes',
    '- Prefer `variant` over typography in `className`.',
    '',
    ...snippets,
  ].join('\n');
}
